import React from 'react';
import Project from '../project/Project.react.js';
import './ProjectOverview.css';

class ProjectOverview extends React.Component {
    constructor(props) {
        super(props);
    
        this.state = {
            projects: [
                {
                    key: 9,
                    name: "Web Sprachsynthese",
                    description: "Mit den neusten Versionen von Chrome, Firefox und Edge wurde der erste Draft der Web Speech API implementiert.<br /> Diese erlaubt den Aufruf von Text-to-Speech Engines aus dem Browser heraus.<br /><br /> Dieser Pen erlaubt es mit kompatiblen Browsern diese Sprachnachrichten per Link zu verschicken.",
                    highlights: [
                        "Ansteuern der Web Speech API gemäß neustem W3C Draft",
                        "Implementierung von Text-Highlighting für Microsoft Stimmen",
                        "Implementierung eines Versandsystems über URL-Parameter"
                    ],
                    image: "webspeech.png",
                    link: "https://codepen.io/Viket/pen/yPNaXg?m=Hallo%20Besucher%20meiner%20Portfolioseite.%20Dieses%20Feld%20ist%20editierbar.%20Gib%20eine%20eigene%20Nachricht%20ein%20und%20teile%20Sie%20mit%20deinen%20Freunden%20%C3%BCber%20den%20Knopf%20unten%20links!",
                    createdFor: "Eigenentwicklung",
                    stack: ["HTML", "CSS", "JavaScript"]
                },
                {
                    key: 1,
                    name: "Haustechnikdialog",
                    description: "Haustechnikdialog.de ist eine Newsseite spezialisiert auf den Haustechnik Bereich und beherbergt das größte deutschsprachige Forum der Branche.",
                    highlights: [
                        "Signifikante Beteiligung an der Umsetzung eines Seitenweiten redesigns",
                        "Sicherung der Webseite gegen SQL-Injections, XSS-Angriffe und Spam",
                        "Quality-of-life Verbesserungen, wie vereinfachte Navigation, einsehbare Postmetadaten uvm."
                    ],
                    image: "haustechnik.png",
                    link: "https://www.haustechnikdialog.de",
                    createdFor: "in Anstellung bei ConSoft GmbH",
                    stack: ["HTML", "CSS", "JavaScript", "XML", "AJAX", "ASP.Net", "Classic ASP", "MSSQL"]
                },
                {
                    key: 2,
                    name: "Dehoustconnect",
                    description: "Dehoustconnect ist eine Webanwendung der Dehoust GmbH, über die Besitzer von Grau- und Regenwasseranlagen oder Sicherheitstrennstationen der Firma, diese verwalten und Fernsteuern können.",
                    highlights: [
                        "Entwicklung von SOAP und REST services zur Kommunikation mit der Dehoust App und den steuerbaren Geräten",
                        "Entwicklung einer webbasierten Live-Steuerung der Geräte unter Verwendung des MQTT Protokolls",
                        "Entwicklung einer Historie eingegangener Daten in Tabellarischer und Graphenansicht"
                    ],
                    image: "dehoust.png",
                    link: "https://www.dehoustconnect.de",
                    createdFor: "in Anstellung bei ConSoft GmbH",
                    stack: ["HTML", "CSS", "JavaScript", "XML", "AJAX", "ASP.Net", "MQTT", "MSSQL"]
                },
                {
                    key: 3,
                    name: "Flippet",
                    description: "Ein in meiner Freizeit entwickeltes Spiel, mit mobile Optimierung.<br /> Ziel des Spiels ist es alle roten Kacheln auf ihre grüne Seite zu drehen. Das Spiel wird durch die auf PIXI.js basierende Phaser Engine angetrieben.",
                    highlights: [
                        "Idee und Konzeptionierung des Spiels",
                        "Implementierung in der Phaser Engine",
                        "Entwicklung der UI mittels herkömmlicher Webtechnologien"
                    ],
                    image: "flippet.png",
                    link: "http://flippet.viket.net",
                    createdFor: "Eigenentwicklung",
                    stack: ["HTML", "CSS", "JavaScript", "JSON", "PIXI.js"]
                },
                {
                    key: 4,
                    name: "Vanilla Snake",
                    description: "Ein durch mich in meiner Freizeit entwicklter Klon des Handyklassikers Snake. Dieser Spieleklon entstand im Zuge einer Herausforderung einen Spieleklassiker ohne Hilfe von 3rd Party Libraries oder anderer moderner Tools wie CSS oder JavaScript Transpiler zu implementieren.",
                    highlights: [
                        "Entwickelung eines HTML5 Spiels ohne Frameworks, Libraries oder Transpiler",
                        "Gemäß Herausforderung in unter einer Stunde entwickelt"
                    ],
                    image: "snake.png",
                    link: "https://codepen.io/Viket/pen/NgWgXZ",
                    createdFor: "Eigenentwicklung",
                    stack: ["HTML", "CSS", "JavaScript"]
                },
                {
                    key: 8,
                    name: "Twitch randomizer",
                    description: "Ein kleines Projekt, dass dem Besucher zufällig aktive Streams auf Twitch vorschlägt.<br /><br /> Zum 31.12.2018 wird Twitch seine bisherige API abschalten. Dieser Pen entstand als Beispielanwendung um den Umgang mit der bereits verfügbaren Nachfolger-API zu lernen. ",
                    highlights: [
                        "HttpRequests an die neue Twitch Helix API",
                        "Konfiguration des eingebetteten Twitch Videoplayers über iFrame Parameter"
                    ],
                    image: "twitchr.png",
                    link: "https://codepen.io/Viket/pen/YEydvJ",
                    createdFor: "Eigenentwicklung",
                    stack: ["HTML", "CSS", "JavaScript", "AJAX"]
                },
                {
                    key: 6,
                    name: "Dehoust Planungshilfen",
                    description: "Planungshilfen zur Auslegung von Regen- und Grauwasseranlagen von Dehoust. Zu finden in der Tools Sektion der Dehoust iPhone App. Die Portierung auf Android erfolgte nicht durch mich.",
                    highlights: [
                        "Entwicklung nativer iPhone Tools unter Beachtung deutscher Industrie Normen",
                        "Integration der Tools in die bestehende App des Kunden"
                    ],
                    image: "dehoust.png",
                    link: "https://itunes.apple.com/de/app/dehoust/id972120142?mt=8",
                    createdFor: "in Anstellung bei ConSoft GmbH",
                    stack: ["Objective-C", "SQLite"]
                },
                {
                    key: 5,
                    name: "Neverpay",
                    description: "Eine aus Neugier entstandene Chromeerweiterung, inspiriert durch diesen Blogpost von Andreas Zeller: <a href='http://andreas-zeller.blogspot.de/2016/06/spiegel-online-nutzt-unsichere-casar.html' style='color: #27ae60;'>http://andreas-zeller.blogspot.de/2016/06/spiegel-online-nutzt-unsichere-casar.html</a>.<br /><br /> Das Plugin selbst teile ich hier aus offensichtlichen Gründen lieber nicht, beantworte aber gerne Fragen dazu.",
                    highlights: [
                        "Behandlung von Markup und Sonderzeichen in einer Ceasar-Chiffre",
                        "Entfernen von Popups und Blur-Filtern",
                        "Wiederherstellen der Interaktivität nicht klickbarer Elemente"
                    ],
                    image: "neverpay.png",
                    link: "",
                    createdFor: "Eigenentwicklung",
                    stack: ["HTML", "CSS", "JavaScript"]
                },
                {
                    key: 7,
                    name: "Mein Portfolio",
                    description: "Die Seite die Sie grade besuchen. Listet einen Auszug von Projekten an denen ich beteiligt war.",
                    highlights: [
                        "Einen hübsch animierten Canvas"
                    ],
                    image: "portfolio.png",
                    link: "http://viket.net",
                    createdFor: "Eigenentwicklung",
                    stack: ["HTML", "CSS", "JavaScript", "React.js"]
                }

            ],
            activeElem: undefined,
            mask: {
                top: 0,
                left: 0,
                width: 0,
                height: 0
            }
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.isResized) {
            let self = this;
            if (self.state.activeElem) {
                let elem = self.state.activeElem.getBoundingClientRect();
                self.setState({
                    mask: {
                        left: elem.left,
                        width: elem.width,
                        top : elem.top + window.scrollY,
                        height: elem.height
                    }
                });
            }
        }
    }
    
    render() {
        return (
            <div id="projects" className="App">
                <div className="mask" style={
                    {
                        top: this.state.mask.top,
                        left: this.state.mask.left,
                        width: this.state.mask.width,
                        height: this.state.mask.height
                    }
                }></div>
                <div className="sectionHead">
                    <h2> Projekte: </h2>
                </div>
                <div className="wrapper">
                    {this.state.projects.map((project) => 
                    <Project key={project.key} obj={project} mask={this.mask} onHover={this.onProjectHover.bind(this)}></Project>
                    )}
                </div>
            </div>
        );
    }
    
    onProjectHover(elem) {
        let org = elem;
        elem = elem.getBoundingClientRect();

        this.setState({
            activeElem: org,
            mask: {
                left: elem.left,
                width: elem.width,
                top : elem.top + window.scrollY,
                height: elem.height
            }
        });

        let hoverables = document.querySelectorAll("*[data-hoverable]");
        for (var i = 0; i < hoverables.length; i++) {
            hoverables[i].parentNode.classList.remove("toggle");
        }
    }
}

export default ProjectOverview;


// WEBPACK FOOTER //
// ./src/ProjectOverview/ProjectOverview.react.js